function formatDate(time) {
var now = new Date(time)
var year = now.getFullYear(),
month = now.getMonth() + 1,
date = now.getDate(),
hour = now.getHours(),
minute = now.getMinutes(),
second = now.getSeconds()
return (
year + '-' + month + '-' + date + ' ' + hour + ':' + minute + ':' + second
)
}
function createSvgTextEl(paramsObj, content) {
//{x:0,y:0,style:}
let TextEl = document.createElement('text')
for (const paramKey in paramsObj) {
TextEl.setAttribute(paramKey, paramsObj[paramKey])
TextEl.setAttribute(paramKey, paramsObj[paramKey])
}
TextEl.innerText = content
return TextEl
}
//判断是否未上班时间
function isWorkDay() {
var weekDay = [
'星期天',
'星期一',
'星期二',
'星期三',
'星期四',
'星期五',
'星期六'
]
var myDate = new Date()
return weekDay[myDate.getDay()] === '星期六' ||
weekDay[myDate.getDay()] === '星期天'
? false
: true
}

//长连接配置
function create_wsConfig(
$this = null, //vue中的this
list = '',//
token = '', //当前登录token
lt = 0, //
isSend = true //真：发送；假：不发送
) {
	let wsConfigObj = {}
	let wsConfigObjData = {}
	let webscoketConfigStr = ''
	wsConfigObjData.list = list
	wsConfigObjData.token = token
	wsConfigObjData.lt = lt
	wsConfigObj.action = 'Futures'
	wsConfigObj.data = wsConfigObjData
	webscoketConfigStr = JSON.stringify(wsConfigObj)
	$this.$store.commit('setWebscoketConfigStr', webscoketConfigStr)
	if (isSend && $this.$store.state.webscoketObj && $this.$store.state.webscoketObj.readyState==1) {
		$this.$store.state.webscoketObj.send(webscoketConfigStr)
	}
}
//获取cookie数据
function getCookie(cookieName) {
	var strCookie = document.cookie
	var arrCookie = strCookie.split('; ')
	for (var i = 0; i < arrCookie.length; i++) {
		var arr = arrCookie[i].split('=')
		if (cookieName == arr[0]) {
			return arr[1]
		}
	}
	return ''
}
export { create_wsConfig }



//////////////////
// WEBPACK FOOTER
// ./static/js/utils/utils.js
// module id = null
// module chunks = 